<template>
  <text-box :label="title" :icon="icon">
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-chart :option="options" :init-options="{renderer: 'canvas'}" autoresize style="height: 300px; width: 100%;"/>
          </v-col>
        </v-row>
      </v-container>
  </text-box>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/component/markLine'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/legendScroll'
import 'echarts/lib/component/dataZoom'
import 'zrender/lib/canvas/canvas'
import numbro from 'numbro'
import TextBox from '@/components/TextBox.vue'

export default {
  data () {
    return {}
  },
  computed: {
    options () {
      return {
        grid: {
          top: 20,
          left: 60,
          right: 60,
          bottom: 40,
          containLabel: true
        },
        tooltip: {
          formatter: function () {
            return ''
          }
        },
        toolbox: {
          show: this.export,
          left: 0,
          feature: {
            dataView: {
              readOnly: true,
              title: this.$t('components.ScatterChart.dataView'),
              lang: [this.$t('components.ScatterChart.dataView'), this.$t('components.ScatterChart.close'), this.$t('components.ScatterChart.refresh')]
            },
            saveAsImage: {
              type: 'png',
              name: this.exportImageName || this.title || 'ExportedImage',
              title: this.$t('components.ScatterChart.saveAsImage')
            }
          },
          showTitle: false,
          tooltip: {
            show: true,
            formatter: function (param) {
              return param.title
            }
          }
        },
        xAxis: {
          type: this.xAxisTypeIsCategory ? 'category' : 'value',
          name: this.xName,
          nameLocation: 'center',
          nameGap: 30,
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLine: {
            show: true
          },
          axisTick: {
            show: true
          },
          axisLabel: {
            formatter: this.xAxisTypeIsCategory ? null : this.formatValue,
            rotate: this.xAxisRotate ? this.xAxisRotate : null
          }
        },
        yAxis: {
          type: 'value',
          name: this.yName,
          nameLocation: 'middle',
          nameGap: 50,
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLine: {
            show: true
          },
          axisTick: {
            show: true
          },
          axisLabel: {
            formatter: this.formatValue
          }
        },
        series: this.series
      }
    },
    series: function () {
      const series = {
        type: 'scatter',
        areaStyle: {},
        data: this.dataArray(this.data),
        symbolSize: 5,
        itemStyle: {
          color: this.color
        }
      }
      return series
    }
  },
  methods: {
    dataArray: function (data) {
      var array = []
      for (var i in data.x) {
        array.push([
          data.x[i],
          data.y[i]
        ])
      }
      return array
    },
    formatValue: function (value) {
      return numbro(value).format({
        average: true,
        lowPrecision: false,
        mantissa: 1,
        optionalMantissa: true
      })
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: function () {
        return 'blue'
      }
    },
    title: {
      type: String,
      required: false,
      default: function () {
        return ''
      }
    },
    exportImageName: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false,
      default: function () {
        return ''
      }
    },
    xName: {
      type: String,
      required: false
    },
    yName: {
      type: String,
      required: false
    },
    xAxisTypeIsCategory: {
      type: Boolean,
      required: false
    },
    xAxisRotate: {
      type: Number,
      required: false
    },
    gridBottomMargin: {
      type: Number,
      required: false
    },
    export: {
      type: Boolean,
      required: false,
      default: function () {
        return false
      }
    }
  },
  components: {
    'v-chart': ECharts,
    TextBox
  }
}
</script>
